import { useNavigation } from '@react-navigation/native';
import memoize from 'lodash/memoize';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity, Text } from 'react-native';
import colors from '../../theme/Colors';
import images from '../../theme/Images';
import { getScreenWidth } from '../../utils/LayoutUtility';
import FastImageView from '../../components/FastImageView';
import size from '../../theme/Fonts';
import { isBlank, isIOS, isPresent } from '../../utils/BooleanUtility';
import { createRoutineParticipation, getPaymentsDetailsForPartialCart, setCometChatUserData,  } from '../../actions/ActionTypes';
import { navigateToScreen } from '../../utils/NavigationUtility';
import { AnalyticsManager, EventParameterKey, EventType } from '../../analytics';
import { API_DOMAIN, cometChatCredentials, IST_OFFSET } from '../../config/Constants';
import { getStoreRef } from '../../store/StoreUtility';
import NavigationService from '../../navigator/NavigationService';
import { setPhoneNumberModalInfo } from '../../actions/LoginActions';
import Utility from '../../utils/Utility';
import Config from 'react-native-config';
import DebouncedTouchableWithoutFeedback from '../../components/shared/DebouncedTouchableWithoutFeedback';
import { generateRequestHeader } from '../../utils/UriUtility';
import { messaging } from '../../libraries/Firebase';
import DynamicLinkManager from '../../utils/DynamicLinkManager';
import { scheduleChatsNotification } from '../Routines/RoutineNotificationUtility';
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import { ShowCountDown } from './ShowCountDown';
import CometChat from '../../libraries/ReactNativeCometChatSdk';

const JSONAPIDeserializer = require('jsonapi-serializer').Deserializer;


const ConversationInfo = ({
  name = '',
  dermatName = '',
  description = '',
  startsAt = '',
  endsAt = '',
  isLiveRoutine = false,
  lastMessage = '',
  lastMessageSender = '',
  isArchived = false,
  unreadMessageCount,
  guid,
  isUpcomingRoutine,
}) => {
  return (
    <View style={{ top: -4 }}>
      <View pad>
        <Text numberOfLines={1} ellipsizeMode='tail' style={styles.conversationTitle}>
          {name}
        </Text>
        <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 2 }}>
          <Text numberOfLines={1} ellipsizeMode='tail' style={styles.conversationSubtitle}>
            By {dermatName}
          </Text>
          {isLiveRoutine && <LiveIndicator />}
        </View>
      </View>
      {!isArchived && (
        <ConversationSubtitle
          description={description}
          isLiveRoutine={isLiveRoutine}
          lastMessageSender={lastMessageSender}
          lastMessage={lastMessage}
          unreadMessageCount={unreadMessageCount}
          guid={guid}
        />
      )}
      {isPresent(startsAt) && (
        <ShowCountDown
          startsAt={startsAt}
          endsAt={endsAt}
          isUpcomingRoutine={isUpcomingRoutine}
          showLeftAlignContainer
          disbale7DaysCountdown={true}
        />
      )}
      {isArchived && <ArchivedTag />}
    </View>
  );
};

const ConversationSubtitle = ({
  lastMessageSender,
  lastMessage,
  isLiveRoutine,
  description,
  unreadMessageCount,
  guid,
}) => {
  if (!isLiveRoutine) return null;

  const UnreadMessagesCount = () => {
    const unreadCount = unreadMessageCount[guid];
    if (!unreadCount) return null;

    return (
      <View style={styles.unreadMessagesCountContainer}>
        <Text style={styles.unreadMessagesCountText}>{unreadCount}</Text>
      </View>
    );
  };

  const containerStyle = isPresent(description)
    ? [styles.conversationContainer, { marginTop: 0 }]
    : styles.conversationContainer;

  return (
    <View style={containerStyle}>
      {lastMessage ? (
        <>
          <Text numberOfLines={2} ellipsizeMode='tail' style={styles.lastMessage}>
            <Text ellipsizeMode='tail' style={styles.lastMessageSender}>
              {lastMessageSender}:{' '}
            </Text>
            {lastMessage}
          </Text>
          {isLiveRoutine && <UnreadMessagesCount />}
        </>
      ) : (
        <Text numberOfLines={1} ellipsizeMode='tail' style={styles.description}>
          {description}
        </Text>
      )}
    </View>
  );
};

const LiveIndicator = () => {
  return (
    <View style={styles.liveIndicatorContainer}>
      <View style={styles.liveIndicator} />
      <Text style={styles.liveIndicatorText}>LIVE</Text>
    </View>
  );
};

const ArchivedTag = () => {
  return (
    <View style={styles.archivedTextContainer}>
      <Text style={styles.archivedText}>Archived</Text>
    </View>
  );
};

const Avatar = ({ icon, isLiveRoutine, handle, navigation }) => {

  const avatarAction = () => {
    if (isBlank(handle)) return;
    DynamicLinkManager.handleLinkWithInternalTrackingParams(handle, ({ route = '', slug = '', extra = {} }) => {
      navigateToScreen({
        navigation,
        type: 'navigate',
        screen: route,
        params: { slug, extra },
      });
    });
  };

  return (
    <View
      style={[
        {
          height: 74,
          width: 74,
          borderRadius: 38,
          justifyContent: 'center',
          marginRight: 12,
          marginTop: -2,
        },
        isLiveRoutine && {
          borderWidth: 1.2,
          borderColor: Config.THEME_COLOR,
          borderRadius: 38,
        },
      ]}
    >
      <DebouncedTouchableWithoutFeedback onPress={avatarAction}>
        <FastImageView source={{ uri: icon || images.empty_profile_photo }} style={[styles.conversationIcon]} />
      </DebouncedTouchableWithoutFeedback>
    </View>
  );
};

const DefaultSizeCometChatGroupList = (props) => {
  const [groupData, setGroupData] = useState({});
  const [unreadMessageCount, setUnreadMessageCount] = useState({});
  const [lastMessage, setLastMessage] = useState('');
  const [lastMessageTimeStamp, setLastMessageTimestamp] = useState(null);
  const [lastMessageSender, setLastMessageSender] = useState('');
  const [loader, setLoader] = useState(false);
  const [userData, setUserData] = useState();
  const dispatch = useDispatch();
  const { itemData = {}, listData: { card_background_color = '' } = {}, index = '' } = props;
  const navigation = useNavigation();
  const state = getStoreRef()?.getState();
  const authToken = state?.UserAccountInfo?.authToken;
  useEffect(() => {
    try {
      new JSONAPIDeserializer({
        typeAsAttribute: false,
        pluralizeType: true,
        keyForAttribute: 'camelCase',
      })
        .deserialize(itemData)
        .then((data) => {
          setGroupData(data);
        });
    } catch (e) {}
  }, []);

  const {
    name = '',
    dermatName = '',
    description = '',
    conversationWith = {},
    conversationWith: { guid = '' } = {},
    cometChatGroupsSchedules = [],
    ctaAction = '',
    status = '',
    nextStartsAt = '',
    nextEndsAt = '',
    routine: {
      endsAt = '',
      artist: { imageUrl, bioHandle = '' } = {},
      slug = '',
    } = {},
  } = groupData;
  const isLiveRoutine = status === 'active';
  const isArchivedRoutine = status === 'archived';
  const isUpcomingRoutine = status === 'upcoming';
  useEffect(() => {
    if (isPresent(cometChatGroupsSchedules)) {
      scheduleChatsNotification(cometChatGroupsSchedules);
    }
  }, [cometChatGroupsSchedules]);
  useEffect(() => {
    const blurListener = navigation.addListener('focus', () => {
      fetchUnreadCount();
      fetchLastMessage();
    });
    return () => {
      blurListener();
    };
  }, [guid]);

  useEffect(() => {
    if (guid) {
      CometChat.addMessageListener(
        guid,
        new CometChat.MessageListener({
          onTextMessageReceived: (textMessage) => {
            console.tron.log('Text message received successfully', textMessage);
          },
          onMediaMessageReceived: (mediaMessage) => {
            fetchUnreadCount();
            fetchLastMessage();
            console.log('Media message received successfully', mediaMessage);
          },
          onCustomMessageReceived: (customMessage) => {
            fetchUnreadCount();
            fetchLastMessage();
            console.tron.log('Custom message received successfully', customMessage);
          },
        }),
      );
    }
    return () => {
      CometChat.removeMessageListener(guid);
    };
  }, [guid]);

  useEffect(() => {
    fetchUnreadCount();
    fetchLastMessage();
  }, [guid, groupData]);

  const fetchUnreadCount = () => {
    if (!guid || !isLiveRoutine) return;
    CometChat.getUnreadMessageCountForGroup(guid).then(
      (group: GroupData) => {
        setUnreadMessageCount(group);
      },
      (error: any) => {
        console.error('Group details fetching failed with exception:', error);
      },
    );
  };

  const selectedLastMessage = (conversation) => {
    const {
      lastMessage: {
        sender: { name: senderName = '' } = {},
        customData: { text = '', productArray = '', question = '' } = {},
        type: messageType = '',
        message = '',
      } = {},
    } = conversation;
    switch (messageType) {
      case 'custom_text':
        return text;
      case 'custom_product':
        return productArray[0]?.name || '';
      case 'video':
        return '📹 Video';
      case 'image':
        return '📷 Photo';
      case 'extension_poll':
        return `📊 ${question}`;
      default:
        return message;
    }
  };

  const fetchLastMessage = () => {
    if (!guid || !isLiveRoutine) return;
    CometChat.getConversation(guid, 'group').then(
      (conversation: Conversation) => {
        const {
          lastMessage: {
            sender: { name: senderName = '' } = {},
            customData: { text = '', productArray = '', question = '' } = {},
            type: messageType = '',
            message = '',
            sentAt,
          } = {},
        } = conversation;
        const lastMessage = selectedLastMessage(conversation);
        setLastMessageTimestamp(sentAt);
        setLastMessage(lastMessage);
        setLastMessageSender(senderName);
      },
      (error: any) => {
        console.error('Group details fetching failed with exception:', error);
      },
    );
  };

  const onPressActionButton = () => {
    if (typeof ctaActions[ctaAction] == 'function') {
      setLoader(true);
      ctaActions[ctaAction]();
    }
  };

  const navigateToPreRoutine = (navigationType = 'navigate') => {
    navigation[navigationType]('PreRoutineDetails', {
      slug,
    });
  };

  const onTapSignUp = () => {
    setLoader(false);
    const { previousScreen = '', item: { data: { id = '', attributes: { name = '' } } } } = props;
    AnalyticsManager.logEvent(EventType.chat.SIGN_UP_BUTTON_CLICK,{
      [EventParameterKey.PREVIOUS_SCREEN]: previousScreen,
      [EventParameterKey.CHAT_ID]: id,
      [EventParameterKey.CHAT_NAME]: name,
    });
    if (isBlank(authToken)) {
      dispatch(setPhoneNumberModalInfo(Utility.getLoginModalInfo('HIPER_FOR_YOU')));
      NavigationService.renderOnboarding({
        furtherAction: checkOrNavigateToProfile,
      });
    } else {
      checkOrNavigateToProfile();
    }
  };

  const checkOrNavigateToProfile = () => {
    const {
      profile: { name: profileName = '', email: profileEmail = '' },
    } = getStoreRef().getState().UserAccountInfo;
    if (isBlank(profileName) || isBlank(profileEmail)) {
      navigation.navigate('ProfileSelection', {
        navigateToMessageInbox: navigateToMessageOrOpenChatPage,
      });
    } else {
      navigateToMessageOrOpenChatPage();
    }
  };

  const navigateToMessageOrOpenChatPage = (navigationType = 'navigate') => {
    if (isBlank(conversationWith)) {
      navigateToPreRoutine(navigationType);
    } else {
      navigateToMessageInbox(groupData, navigationType);
    }
  };

  const navigateToMessageInbox = (item, type = 'navigate') => {
    navigation[type](SCREEN_CONSTANTS.MESSAGES, {
      item,
      isArchived: isArchivedRoutine,
      cometChatGroupsSchedules,
      isUpcoming: isUpcomingRoutine,
    }); // navigate to CometChatMessages screen
  };

  const ctaActions = {
    join_chat: onTapSignUp,
    joined: onTapSignUp,
  };

  const containerStyle =
    index === 0
      ? [styles.listItemStyle, { backgroundColor: card_background_color || '#D5DEEF' }]
      : [styles.listItemStyle, { backgroundColor: card_background_color || '#D5DEEF' }];
  const signup = ctaAction === 'join_chat';
  let timeStampText = '';
  if (isArchivedRoutine) {
    timeStampText = moment(endsAt).format('DD/MM/YYYY');
  } else if (lastMessageTimeStamp) {
    timeStampText = moment.unix(lastMessageTimeStamp).format('hh:mm A');
  }
  const unreadCount = unreadMessageCount[guid];
  return (
    <View style={{ backgroundColor: card_background_color || '#D5DEEF' }}>
      <DebouncedTouchableWithoutFeedback onPress={onPressActionButton} style={containerStyle}>
        <Avatar icon={imageUrl} isLiveRoutine={isLiveRoutine} handle={bioHandle} navigation={navigation} />
        <ConversationInfo
          name={name}
          dermatName={dermatName}
          description={description}
          lastMessage={lastMessage}
          lastMessageSender={lastMessageSender}
          startsAt={nextStartsAt}
          endsAt={nextEndsAt}
          isLiveRoutine={isLiveRoutine}
          isArchived={isArchivedRoutine}
          unreadMessageCount={unreadMessageCount}
          guid={guid}
          isUpcomingRoutine={isUpcomingRoutine}
          signup={signup}
        />
        {isPresent(ctaAction) && ctaAction !== 'joined' && !isArchivedRoutine && (
          <TouchableOpacity
            style={styles.joinNowButton}
            onPress={onPressActionButton}
            disabled={ctaAction === 'joined'}
          >
            <Text style={styles.buttonText}>{'Sign Up'}</Text>
          </TouchableOpacity>
        )}
        <View style={styles.indicatorContainer}>
          {<Text style={[styles.archivedDateText, unreadCount && { color: '#1f2070' }]}>{timeStampText}</Text>}
        </View>
      </DebouncedTouchableWithoutFeedback>
      <View style={styles.divider} />
    </View>
  );
};

export default DefaultSizeCometChatGroupList;

const styles = StyleSheet.create({
  tabImageStyle: {
    height: 24,
    width: 24,
    resizeMode: 'contain',
  },
  toastStyle: {
    position: 'absolute',
    bottom: 100,
  },
  container: {
    flex: 1,
    backgroundColor: colors.background,
    marginTop: 50,
  },
  listItemStyle: {
    backgroundColor: colors.hiper_chat_container,
    marginHorizontal: -6,
    flexDirection: 'row',
    padding: 12,
    width: getScreenWidth(),
    alignSelf: 'center',
  },
  conversationIcon: {
    height: 68,
    width: 68,
    borderRadius: 35,
    borderWidth: 1,
    borderColor: colors.subtitle,
    alignSelf: 'center',
  },
  tailedCircle: {
    position: 'absolute',
    height: 57,
    width: 57,
    alignSelf: 'center',
    left: 9,
    top: 9,
  },
  flexContainer: {
    flex: 1,
  },
  conversationTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 16,
    color: colors.black,
    width: getScreenWidth() - 180,
    paddingRight: 2,
  },
  conversationSubtitle: {
    fontFamily: 'Roboto-Medium',
    fontSize: 12,
    color: colors.black,
    lineHeight: 16,
    marginTop: 2,
    maxWidth: '75%',
  },
  conversationBody: {
    fontFamily: 'Roboto-Medium',
    fontSize: 12,
    color: colors.black,
  },
  conversationLastMessageSender: {
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    color: colors.subtitle,
  },
  conversationLastMessage: {
    fontFamily: 'Roboto-Regular',
    fontSize: 12,
    color: colors.subtitle,
  },
  liveIndicatorContainer: {
    borderRadius: 4,
    borderWidth: 1,
    borderColor: colors.foxyRed,
    padding: 1,
    paddingHorizontal: 3,
    marginLeft: 4,
    alignSelf: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 2,
  },
  liveIndicator: {
    height: 3,
    width: 3,
    borderRadius: 3,
    marginRight: 2,
    backgroundColor: colors.foxyRed,
  },
  liveIndicatorText: {
    fontFamily: 'Roboto-Bold',
    color: colors.foxyRed,
    fontSize: 8,
  },
  indicatorContainer: {
    alignItems: 'center',
    position: 'absolute',
    right: 12,
    top: 12,
  },

  joinNowButton: {
    height: 20,
    width: 60,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1B1F6A',
    borderRadius: 10,
    padding: 2,
    paddingVertical: 1.5,
    top: 18,
  },

  buttonText: {
    fontSize: size.h5,
    color: colors.white,
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'Roboto-Medium',
  },

  liveContainer: {
    backgroundColor: colors.routine_card_pink,
    borderRadius: 2,
    paddingHorizontal: 12,
    paddingVertical: 2,
    marginLeft: 6,
    position: 'absolute',
    left: 4,
    top: 12,
  },
  liveText: {
    color: colors.white,
    fontSize: size.h4_5,
    fontFamily: 'Roboto-Medium',
  },
  countdownContainer: {
    flexDirection: 'row',
    paddingRight: 8,
    marginLeft: -6,
    paddingVertical: 2,
    alignItems: 'center',
  },
  countdownText: {
    color: colors.black,
    fontFamily: 'Roboto-Medium',
    fontSize: size.h4,
    paddingHorizontal: 6,
    alignSelf: 'center',
    marginTop: 4,
  },
  dateText: {
    color: colors.black,
    fontFamily: 'Roboto-Medium',
    fontSize: size.h4,
    alignSelf: 'center',
    height: 16,
    marginTop: 2,
  },
  digitStyle: {
    backgroundColor: colors.black,
    borderRadius: 4,
  },
  digitTxtStyle: {
    color: colors.white,
    fontSize: size.h5,
    fontFamily: 'Roboto-Regular',
  },
  timeLabelStyle: {
    color: colors.black,
    fontFamily: 'Roboto-Regular',
    fontSize: 9,
    marginTop: 0,
    marginLeft: 2.1,
  },
  separatorStyle: {
    color: colors.black,
    marginTop: 3,
    marginLeft: 1,
  },
  archivedTextContainer: {
    padding: 4,
    borderRadius: 4,
    backgroundColor: colors.grey,
    maxWidth: 50,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 4,
  },
  archivedText: {
    fontSize: 10,
    fontFamily: 'Roboto-Medium',
    color: colors.white,
  },
  archivedConversationTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 16,
    color: colors.black,
    width: getScreenWidth() - 174,
    paddingRight: 2,
    lineHeight: 16,
  },
  archivedDateText: {
    fontSize: 12,
    fontFamily: 'Roboto-Regular',
    color: colors.darkGrey,
  },
  subContainer: {},
  divider: {
    marginLeft: 188,
    width: '100%',
    height: 1,
    backgroundColor: colors.lightGrey,
    alignSelf: 'center',
  },
  conversationContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 6,
  },
  lastMessageSender: {
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    color: '#000',
  },
  lastMessage: {
    fontFamily: 'Roboto-Regular',
    fontSize: 12,
    color: '#555',
    width: getScreenWidth() - 132,
    // marginTop: 12,
  },
  description: {
    fontFamily: 'Roboto-Regular',
    fontSize: 12,
    color: '#555',
    width: getScreenWidth() - 164,
  },
  unreadMessagesCountContainer: {
    marginLeft: 8,
    backgroundColor: '#1B1F6A',
    borderRadius: 12,
    paddingHorizontal: 6,
    paddingVertical: 2,
  },
  unreadMessagesCountText: {
    color: colors.white,
    fontSize: 10,
    fontFamily: 'Roboto-Medium',
  },
});
